import { Injectable } from '@angular/core';

import {
  Intercom as IntercomWeb,
  show,
  showArticle,
  showNewMessage,
  showSpace,
  shutdown,
  trackEvent,
  update,
} from '@intercom/messenger-js-sdk';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class IntercomService {

  initialize() {
    IntercomWeb({
      app_id: environment.intercomWorkspace,
      app_type: 'website',
    });
  }

  async helpCenter() {
    showSpace('help');
  }

  newMessage() {
    showNewMessage('');
  }

  displayMessenger() {
    show();
  }

  logout() {
    shutdown();
  }

  updateUser(user: { email?: string; name?: string }) {
    update(user);
  }

  trackEvent(eventName: string, metaData?: any) {
    trackEvent(eventName, metaData);
  }

  shutdown() {
    shutdown();
  }

  showArticle(articleId: string) {
    showArticle(articleId);
  }

  reportAnIssue() {
    trackEvent('report-a-problem');
  }

  /**
   * Checks if the Intercom instance is available.
   * @returns boolean - True if the Intercom instance is available.
   */
  isIntercomAvailable(): boolean {
    return typeof (window as any).Intercom === 'function';
  }
}
